<template>
<div class="Acknowlegdement">
        <!-- <div class="row justify-center full-height"> -->
            <!-- <q-banner rounded class=""> -->
            <!-- <q-card style=""> -->
                <q-card-section style="">
                    <div class="col">
                        <Success v-if="StoreStateAD.TC_TransactionStatus=='0000'"></Success>
                    </div>
                    <div class="col">
                        <Fail v-if="StoreStateAD.TC_TransactionStatus!='0000'"></Fail>
                    </div>
                </q-card-section>

                <!-- <q-card-section>
                    <AD class=""/>
                </q-card-section> -->

                <q-card-section>
                    <div class="" style="display: flex;">
                        
                            <Navigation 
                                class="AckBtn q-pr-md"
                                :ShowBackToButton=true
                                BackToButtonColor=""
                                BackToButtonTextColor="Black"
                                @BackToButton="Redirect()"
                              style="margin-left: auto;"
                            />
                            
                            <Navigation
                                style=""
                                class="AckBtn"
                                :ShowPrintButton=true
                                @PrintButton="PrintFunction()"
                            />
                        
                    </div>
                </q-card-section>
            <!-- </q-card> -->
			    <!-- </q-banner> -->
        <!-- </div> -->
</div>
    
</template>
<script>
import { mapActions } from 'vuex';
import store from '../store'

import AD from '@/components/AccountDetails.vue'
import Success from '@/components/GateWaySuccess.vue'
import Fail from '@/components/GateWayFail.vue'
import Navigation from '@/components/NavigationButtons'
export default {
    name : 'Acknowlegdement',
    components : {
        AD,
        Success,
        Fail,
        Navigation
    },
    data() {
        return {
            StoreStateT : store.state.Transactions,
            StoreStateAD : store.state.AD,
            StoreStateLogin: store.state.Login,
            IAkaunUrl : process.env.VUE_APP_IAKAUN_URL 
        }
    },
    computed: {

    },
    methods: {
        PrintFunction: function() {
            window.print();
        },
        Redirect: function(){
           window.location.href = this.IAkaunUrl
           // 'https://iakaunuat2.epf.gov.my/member/member/login'
           //  https://iakaunsit2.epf.gov.my/member/member/login
        }

    }
}
</script>


<style >
@media print {
    .Acknowlegdement{
        display : block;
    }
    .q-stepper__header{
        display : none;
    }
}
</style>